<!-- ============================================================
     INVENTORY MANAGEMENT SYSTEM
     ============================================================ -->
<div class="inv-page">

  <!-- ── TOAST ─────────────────────────────────────────────── -->
  @if (toast()) {
    <div class="inv-toast alert alert-success d-flex align-items-center gap-2 shadow">
      <i class="bi bi-check-circle-fill fs-5"></i><strong>{{ toast() }}</strong>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       ADD STOCK MODAL
       ══════════════════════════════════════════════════════ -->
  @if (showAddStockModal()) {
    <div class="inv-overlay" (click)="showAddStockModal.set(false)">
      <div class="inv-modal" (click)="$event.stopPropagation()">
        <div class="imh imh-green">
          <div class="imh-icon"><i class="bi bi-box-arrow-in-down"></i></div>
          <div><h5 class="imh-title">Add / Receive Stock</h5><p class="imh-sub">{{ addStockForm.item_name }}</p></div>
          <button class="imh-close" (click)="showAddStockModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-3">
            @if (!addStockForm.item_id) {
              <div class="col-12">
                <label class="form-label fw-semibold">Item <span class="req">*</span></label>
                <select class="form-select" [(ngModel)]="addStockForm.item_id" (change)="addStockForm.item_name = items().find(i=>i.id===addStockForm.item_id)?.item_name ?? ''">
                  <option [ngValue]="null">Select item…</option>
                  @for (i of items(); track i.id) { <option [ngValue]="i.id">{{ i.item_sku }} – {{ i.item_name }}</option> }
                </select>
              </div>
            }
            <div class="col-md-4">
              <label class="form-label fw-semibold">Quantity <span class="req">*</span></label>
              <input type="number" class="form-control" [(ngModel)]="addStockForm.quantity" min="1" [class.is-invalid]="stkSubmitted && !(addStockForm.quantity > 0)">
              @if (stkSubmitted && !(addStockForm.quantity > 0)) { <div class="invalid-feedback">Required.</div> }
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Unit Price (₹)</label>
              <input type="number" class="form-control" [(ngModel)]="addStockForm.unit_price" min="0">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Ref. / PO No.</label>
              <input type="text" class="form-control" [(ngModel)]="addStockForm.reference" maxlength="50">
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Notes</label>
              <input type="text" class="form-control" [(ngModel)]="addStockForm.notes" maxlength="200">
            </div>
          </div>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary px-4" (click)="showAddStockModal.set(false)">Cancel</button>
          <button class="btn inv-btn-primary px-5" (click)="saveAddStock()"><i class="bi bi-check-circle-fill me-1"></i>Add Stock</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       ITEM MODAL
       ══════════════════════════════════════════════════════ -->
  @if (showItemModal()) {
    <div class="inv-overlay" (click)="showItemModal.set(false)">
      <div class="inv-modal-lg" (click)="$event.stopPropagation()">
        <div class="imh imh-primary">
          <div class="imh-icon"><i class="bi bi-box-seam-fill"></i></div>
          <div><h5 class="imh-title">{{ editingId() ? 'Edit Item' : 'New Inventory Item' }}</h5></div>
          <button class="imh-close" (click)="showItemModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-3">
            <div class="col-md-3">
              <label class="form-label fw-semibold">SKU / Code <span class="req">*</span></label>
              <input type="text" class="form-control font-mono" [(ngModel)]="itemForm.item_sku" maxlength="20" placeholder="e.g. STN-001" [class.is-invalid]="itemSubmitted && !itemForm.item_sku?.trim()">
            </div>
            <div class="col-md-5">
              <label class="form-label fw-semibold">Item Name <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="itemForm.item_name" maxlength="100" [class.is-invalid]="itemSubmitted && !itemForm.item_name?.trim()">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Category</label>
              <select class="form-select" [(ngModel)]="itemForm.category">
                @for (c of dataService.inv_item_cat; track c) { <option [value]="c.code">{{ c.name }}</option> }
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label fw-semibold">Opening Stock</label>
              <input type="number" class="form-control" [(ngModel)]="itemForm.current_stock" min="0">
            </div>
            <div class="col-md-3">
              <label class="form-label fw-semibold">Min Stock</label>
              <input type="number" class="form-control" [(ngModel)]="itemForm.min_stock" min="0">
            </div>
            <div class="col-md-3">
              <label class="form-label fw-semibold">Max Stock</label>
              <input type="number" class="form-control" [(ngModel)]="itemForm.max_stock" min="0">
            </div>
            <div class="col-md-3">
              <label class="form-label fw-semibold">Cost Price (₹)</label>
              <div class="input-group"><span class="input-group-text">₹</span>
                <input type="number" class="form-control" [(ngModel)]="itemForm.cost_price" min="0">
              </div>
            </div>
            <div class="col-md-2">
              <label class="form-label fw-semibold">Unit</label>
              <select class="form-select" [(ngModel)]="itemForm.unit">
                @for (u of ['Pcs','Box','Kg','Ltr','Pack','Ream','Dozen','Set','Pair','Roll']; track u) { <option [value]="u">{{ u }}</option> }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Supplier</label>
              <select class="form-select" [(ngModel)]="itemForm.supplier_id" (change)="itemForm.supplier_name = suppliers().find(s=>s.id===itemForm.supplier_id)?.sup_name ?? ''">
                <option [ngValue]="0">Select…</option>
                @for (s of suppliers(); track s.id) { <option [ngValue]="s.id">{{ s.sup_name }}</option> }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Storage Location</label>
              <input type="text" class="form-control" [(ngModel)]="itemForm.storage_location" maxlength="50" placeholder="e.g. Store-A1">
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Description</label>
              <input type="text" class="form-control" [(ngModel)]="itemForm.description" maxlength="200">
            </div>
          </div>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary px-4" (click)="showItemModal.set(false)">Cancel</button>
          <button class="btn inv-btn-primary px-5" (click)="saveItem()"><i class="bi bi-check-circle-fill me-1"></i>Save Item</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       SUPPLIER MODAL
       ══════════════════════════════════════════════════════ -->
  @if (showSupplierModal()) {
    <div class="inv-overlay" (click)="showSupplierModal.set(false)">
      <div class="inv-modal-lg" (click)="$event.stopPropagation()">
        <div class="imh imh-purple">
          <div class="imh-icon"><i class="bi bi-building-fill"></i></div>
          <div><h5 class="imh-title">{{ editingId() ? 'Edit Supplier' : 'New Supplier' }}</h5></div>
          <button class="imh-close" (click)="showSupplierModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Supplier Name <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.sup_name" maxlength="100" [class.is-invalid]="supSubmitted && !supplierForm.sup_name?.trim()">
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Contact Person</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.contact_person" maxlength="80">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Email</label>
              <input type="email" class="form-control" [(ngModel)]="supplierForm.email" maxlength="100">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Phone</label>
              <input type="tel" class="form-control" [(ngModel)]="supplierForm.phone" maxlength="15">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">City</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.city" maxlength="60">
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Address</label>
              <input type="text" class="form-control" [(ngModel)]="supplierForm.address" maxlength="200">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">GST Number</label>
              <input type="text" class="form-control font-mono" [(ngModel)]="supplierForm.gst_no" maxlength="15">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Payment Terms</label>
              <select class="form-select" [(ngModel)]="supplierForm.payment_terms">
                @for (t of ['Immediate','7 days','15 days','30 days','45 days','60 days']; track t) { <option [value]="t">{{ t }}</option> }
              </select>
            </div>
          </div>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary px-4" (click)="showSupplierModal.set(false)">Cancel</button>
          <button class="btn inv-btn-primary px-5" (click)="saveSupplier()"><i class="bi bi-check-circle-fill me-1"></i>Save Supplier</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       PURCHASE ORDER MODAL
       ══════════════════════════════════════════════════════ -->
  @if (showPOModal()) {
    <div class="inv-overlay" (click)="showPOModal.set(false)">
      <div class="inv-modal-xl" (click)="$event.stopPropagation()">
        <div class="imh imh-amber">
          <div class="imh-icon"><i class="bi bi-cart-fill"></i></div>
          <div><h5 class="imh-title">New Purchase Order</h5></div>
          <button class="imh-close" (click)="showPOModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-3 mb-4">
            <div class="col-md-3">
              <label class="form-label fw-semibold">Supplier <span class="req">*</span></label>
              <select class="form-select" [(ngModel)]="poForm.supplier_id" (change)="poForm.supplier_name = suppliers().find(s=>s.id===poForm.supplier_id)?.sup_name ?? ''" [class.is-invalid]="poSubmitted && !poForm.supplier_name">
                <option [ngValue]="null">Select supplier…</option>
                @for (s of suppliers(); track s.id) { <option [ngValue]="s.id">{{ s.sup_name }}</option> }
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label fw-semibold">Order Date</label>
              <input type="date" class="form-control" [(ngModel)]="poForm.order_date">
            </div>
            <div class="col-md-2">
              <label class="form-label fw-semibold">Expected Delivery</label>
              <input type="date" class="form-control" [(ngModel)]="poForm.expected_date">
            </div>
            <div class="col-md-5">
              <label class="form-label fw-semibold">Notes</label>
              <input type="text" class="form-control" [(ngModel)]="poForm.notes" maxlength="200">
            </div>
          </div>
          <!-- PO Line Items -->
          <table class="inv-table mb-2">
            <thead><tr><th>Item</th><th class="text-center" style="width:80px;">Qty</th><th class="text-center" style="width:110px;">Unit (₹)</th><th class="text-end" style="width:110px;">Total</th><th style="width:38px;"></th></tr></thead>
            <tbody>
              @for (ln of poForm.items; track $index) {
                <tr>
                  <td>
                    <select class="form-select form-select-sm" [(ngModel)]="ln.item_id" (change)="ln.item_name=items().find(i=>i.id===ln.item_id)?.item_name??''; ln.item_sku=items().find(i=>i.id===ln.item_id)?.item_sku??''; ln.unit=items().find(i=>i.id===ln.item_id)?.unit??'Pcs'; ln.unit_price=items().find(i=>i.id===ln.item_id)?.cost_price??0; updatePOLineTotal(ln)">
                      <option [ngValue]="0">Select item…</option>
                      @for (it of items(); track it.id) { <option [ngValue]="it.id">{{ it.item_sku }} – {{ it.item_name }}</option> }
                    </select>
                  </td>
                  <td><input type="number" class="form-control form-control-sm text-center" [(ngModel)]="ln.quantity" min="1" (input)="updatePOLineTotal(ln)"></td>
                  <td><input type="number" class="form-control form-control-sm text-end"   [(ngModel)]="ln.unit_price" min="0" (input)="updatePOLineTotal(ln)"></td>
                  <td class="text-end fw-semibold small">{{ formatFull(ln.total ?? 0) }}</td>
                  <td>
                    @if (poForm.items.length > 1) {
                      <button class="del-line-btn" (click)="removePOLine($index)"><i class="bi bi-trash3"></i></button>
                    }
                  </td>
                </tr>
              }
              <tr class="po-total-row">
                <td colspan="3" class="fw-bold ps-3">Order Total</td>
                <td class="text-end fw-bold pe-2">{{ formatFull(poTotal()) }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <button class="btn btn-sm btn-outline-primary mt-1" (click)="addPOLine()"><i class="bi bi-plus-circle me-1"></i>Add Item</button>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary px-4" (click)="showPOModal.set(false)">Cancel</button>
          <button class="btn inv-btn-primary px-5" (click)="savePO()"><i class="bi bi-check-circle-fill me-1"></i>Create PO</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       ISSUE REQUEST MODAL
       ══════════════════════════════════════════════════════ -->
  @if (showIssueModal()) {
    <div class="inv-overlay" (click)="showIssueModal.set(false)">
      <div class="inv-modal-xl" (click)="$event.stopPropagation()">
        <div class="imh imh-teal">
          <div class="imh-icon"><i class="bi bi-box-arrow-up-right"></i></div>
          <div><h5 class="imh-title">Stock Issue Request</h5></div>
          <button class="imh-close" (click)="showIssueModal.set(false)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-3 mb-4">
            <div class="col-md-4">
              <label class="form-label fw-semibold">Department <span class="req">*</span></label>
              <select class="form-select" [(ngModel)]="issueForm.department" [class.is-invalid]="issSubmitted && !issueForm.department">
                <option value="">Select…</option>
                @for (d of ['Science Department','IT Lab','Administration','Sports Department','Library','Mathematics Dept','English Dept','Arts & Craft','Commerce Dept','Management','Canteen']; track d) { <option [value]="d">{{ d }}</option> }
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Requested By <span class="req">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="issueForm.requested_by" maxlength="80" placeholder="Staff name" [class.is-invalid]="issSubmitted && !issueForm.requested_by">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Purpose</label>
              <input type="text" class="form-control" [(ngModel)]="issueForm.purpose" maxlength="200" placeholder="Brief purpose">
            </div>
          </div>
          <table class="inv-table mb-2">
            <thead><tr><th>Item</th><th class="text-center" style="width:120px;">Qty Requested</th><th style="width:38px;"></th></tr></thead>
            <tbody>
              @for (ln of issueForm.items; track $index) {
                <tr>
                  <td>
                    <select class="form-select form-select-sm" [(ngModel)]="ln.item_id" (change)="ln.item_name=items().find(i=>i.id===ln.item_id)?.item_name??''; ln.item_sku=items().find(i=>i.id===ln.item_id)?.item_sku??''; ln.unit=items().find(i=>i.id===ln.item_id)?.unit??'Pcs'">
                      <option [ngValue]="0">Select item…</option>
                      @for (it of items(); track it.id) { <option [ngValue]="it.id">{{ it.item_sku }} – {{ it.item_name }} (Avail: {{ it.current_stock }} {{ it.unit }})</option> }
                    </select>
                  </td>
                  <td><input type="number" class="form-control form-control-sm text-center" [(ngModel)]="ln.requested_qty" min="1"></td>
                  <td>
                    @if (issueForm.items.length > 1) {
                      <button class="del-line-btn" (click)="removeIssueLine($index)"><i class="bi bi-trash3"></i></button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <button class="btn btn-sm btn-outline-primary mt-1" (click)="addIssueLine()"><i class="bi bi-plus-circle me-1"></i>Add Item</button>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary px-4" (click)="showIssueModal.set(false)">Cancel</button>
          <button class="btn inv-btn-primary px-5" (click)="saveIssueRequest()"><i class="bi bi-check-circle-fill me-1"></i>Submit Request</button>
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       PO VIEW MODAL
       ══════════════════════════════════════════════════════ -->
  @if (viewingPO()) {
    @let vp = viewingPO()!;
    <div class="inv-overlay" (click)="viewingPO.set(null)">
      <div class="inv-modal-lg" (click)="$event.stopPropagation()">
        <div class="imh imh-amber">
          <div class="imh-icon"><i class="bi bi-cart-check-fill"></i></div>
          <div><h5 class="imh-title">{{ vp.po_no }}</h5><p class="imh-sub">{{ vp.supplier_name }}</p></div>
          <span class="{{ getPOStatusClass(vp.status) }} ms-auto me-3">{{ vp.status }}</span>
          <button class="imh-close" (click)="viewingPO.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-2 mb-3">
            <div class="col-md-4"><div class="kv-item"><span>Order Date</span><span>{{ formatDate(vp.order_date) }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Expected</span><span>{{ formatDate(vp.expected_date) }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Received</span><span>{{ formatDate(vp.received_date) }}</span></div></div>
            @if (vp.notes) { <div class="col-12"><div class="kv-item"><span>Notes</span><span>{{ vp.notes }}</span></div></div> }
          </div>
          <table class="inv-table">
            <thead><tr><th>Item</th><th>SKU</th><th class="text-center">Ordered</th><th class="text-center">Received</th><th class="text-end">Unit Price</th><th class="text-end">Total</th></tr></thead>
            <tbody>
              @for (ln of vp.items; track ln.item_id) {
                <tr>
                  <td class="fw-semibold small">{{ ln.item_name }}</td>
                  <td class="font-mono small">{{ ln.item_sku }}</td>
                  <td class="text-center">{{ ln.quantity }} {{ ln.unit }}</td>
                  <td class="text-center {{ ln.received_qty >= ln.quantity ? 'text-success fw-semibold' : ln.received_qty > 0 ? 'text-warning' : '' }}">{{ ln.received_qty }}</td>
                  <td class="text-end">{{ formatFull(ln.unit_price) }}</td>
                  <td class="text-end fw-semibold">{{ formatFull(ln.total) }}</td>
                </tr>
              }
              <tr class="po-total-row">
                <td colspan="5" class="fw-bold">Order Total</td>
                <td class="text-end fw-bold">{{ formatFull(vp.total_amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary" (click)="viewingPO.set(null)">Close</button>
          @if (vp.status === 'Draft') { <button class="btn btn-warning" (click)="viewingPO.set(null); sendPO(vp)"><i class="bi bi-send-fill me-1"></i>Send PO</button> }
          @if (vp.status === 'Sent' || vp.status === 'Partial') { <button class="btn btn-success" (click)="viewingPO.set(null); receivePO(vp.id)"><i class="bi bi-box-arrow-in-down me-1"></i>Mark Received</button> }
        </div>
      </div>
    </div>
  }

  <!-- ══════════════════════════════════════════════════════
       ISSUE VIEW MODAL
       ══════════════════════════════════════════════════════ -->
  @if (viewingIssue()) {
    @let vi = viewingIssue()!;
    <div class="inv-overlay" (click)="viewingIssue.set(null)">
      <div class="inv-modal-lg" (click)="$event.stopPropagation()">
        <div class="imh imh-teal">
          <div class="imh-icon"><i class="bi bi-box-arrow-up-right"></i></div>
          <div><h5 class="imh-title">{{ vi.issue_no }}</h5><p class="imh-sub">{{ vi.department }} · {{ vi.requested_by }}</p></div>
          <span class="{{ getIssStatusClass(vi.status) }} ms-auto me-3">{{ vi.status }}</span>
          <button class="imh-close" (click)="viewingIssue.set(null)"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="imb p-4">
          <div class="row g-2 mb-3">
            <div class="col-md-4"><div class="kv-item"><span>Request Date</span><span>{{ formatDate(vi.request_date) }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Issue Date</span><span>{{ formatDate(vi.issue_date) }}</span></div></div>
            <div class="col-md-4"><div class="kv-item"><span>Approved By</span><span>{{ vi.approved_by || '—' }}</span></div></div>
            @if (vi.purpose) { <div class="col-12"><div class="kv-item"><span>Purpose</span><span>{{ vi.purpose }}</span></div></div> }
          </div>
          <table class="inv-table">
            <thead><tr><th>Item</th><th>SKU</th><th class="text-center">Requested</th><th class="text-center">Issued</th></tr></thead>
            <tbody>
              @for (ln of vi.items; track ln.item_id) {
                <tr>
                  <td class="fw-semibold small">{{ ln.item_name }}</td>
                  <td class="font-mono small">{{ ln.item_sku }}</td>
                  <td class="text-center">{{ ln.requested_qty }} {{ ln.unit }}</td>
                  <td class="text-center {{ ln.issued_qty > 0 ? 'text-success fw-semibold' : 'text-muted' }}">{{ ln.issued_qty }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="imf">
          <button class="btn btn-outline-secondary" (click)="viewingIssue.set(null)">Close</button>
          @if (vi.status === 'Pending') { <button class="btn btn-primary" (click)="viewingIssue.set(null); approveIssue(vi.id)"><i class="bi bi-check-circle-fill me-1"></i>Approve</button> }
          @if (vi.status === 'Approved') { <button class="btn btn-success" (click)="viewingIssue.set(null); issueStock(vi.id)"><i class="bi bi-box-arrow-up-right me-1"></i>Issue Stock</button> }
        </div>
      </div>
    </div>
  }

  <!-- ════════════════════════════════════════════════════════
       PAGE HEADER
       ════════════════════════════════════════════════════════ -->
  <div class="inv-ph mb-4">
    <div>
      <h1 class="inv-title"><i class="bi bi-boxes me-2 text-primary" style="font-size:1.1rem;"></i>Inventory Management</h1>
      <p class="inv-subtitle">Track stock · Purchase orders · Issue management · Supplier catalog</p>
    </div>
    <div class="d-flex gap-2 flex-wrap">
      @if (activeTab() === 'items')     { <button class="btn inv-btn-primary btn-sm" (click)="openItemForm()"><i class="bi bi-plus-circle-fill me-1"></i>Add Item</button> }
      @if (activeTab() === 'stock')     { <button class="btn inv-btn-primary btn-sm" (click)="openAddStock()"><i class="bi bi-box-arrow-in-down me-1"></i>Receive Stock</button> }
      @if (activeTab() === 'purchases') { <button class="btn inv-btn-primary btn-sm" (click)="openPOForm()"><i class="bi bi-cart-plus-fill me-1"></i>New PO</button> }
      @if (activeTab() === 'issues')    { <button class="btn inv-btn-primary btn-sm" (click)="openIssueForm()"><i class="bi bi-plus-circle-fill me-1"></i>Issue Request</button> }
      @if (activeTab() === 'suppliers') { <button class="btn inv-btn-primary btn-sm" (click)="openSupplierForm()"><i class="bi bi-plus-circle-fill me-1"></i>Add Supplier</button> }
    </div>
  </div>

  <!-- TABS -->
  <div class="inv-tabs mb-4">
    @for (t of [{k:'dashboard',l:'Dashboard',ic:'bi-grid-fill'},{k:'items',l:'Item Master',ic:'bi-box-seam-fill'},{k:'stock',l:'Stock Levels',ic:'bi-bar-chart-fill'},{k:'purchases',l:'Purchase Orders',ic:'bi-cart-fill'},{k:'issues',l:'Stock Issues',ic:'bi-box-arrow-up-right'},{k:'suppliers',l:'Suppliers',ic:'bi-building-fill'},{k:'reports',l:'Reports',ic:'bi-file-earmark-bar-graph-fill'}]; track t.k) {
      <button class="itab" [class.active]="activeTab() === t.k" (click)="activeTab.set($any(t.k))">
        <i class="bi {{ t.ic }} me-1"></i>{{ t.l }}
        @if (t.k === 'issues'    && issueStats().pending > 0)  { <span class="itab-badge">{{ issueStats().pending }}</span> }
        @if (t.k === 'purchases' && poStats().pending > 0)     { <span class="itab-badge">{{ poStats().pending }}</span> }
      </button>
    }
  </div>

  <!-- ════════════════════════════════════════════════════════
       DASHBOARD
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'dashboard') {
    <!-- KPI Row -->
    <div class="inv-kpi-row mb-4">
      <div class="kpi-card kpi-items">
        <div class="kpi-icon"><i class="bi bi-boxes"></i></div>
        <div class="kpi-body"><div class="kpi-val">{{ itemStats().total }}</div><div class="kpi-label">Total Items</div><div class="kpi-sub">{{ itemStats().categories }} categories</div></div>
      </div>
      <div class="kpi-card kpi-value">
        <div class="kpi-icon"><i class="bi bi-currency-rupee"></i></div>
        <div class="kpi-body"><div class="kpi-val">{{ formatCurrency(itemStats().totalValue) }}</div><div class="kpi-label">Inventory Value</div><div class="kpi-sub">At cost price</div></div>
      </div>
      <div class="kpi-card kpi-low" [class.kpi-alert]="itemStats().lowStock > 0 || itemStats().outOfStock > 0">
        <div class="kpi-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
        <div class="kpi-body"><div class="kpi-val">{{ itemStats().lowStock + itemStats().outOfStock }}</div><div class="kpi-label">Needs Attention</div><div class="kpi-sub">{{ itemStats().outOfStock }} out of stock</div></div>
      </div>
      <div class="kpi-card kpi-po">
        <div class="kpi-icon"><i class="bi bi-cart-fill"></i></div>
        <div class="kpi-body"><div class="kpi-val">{{ poStats().pending }}</div><div class="kpi-label">POs Pending</div><div class="kpi-sub">{{ poStats().draft }} drafts</div></div>
      </div>
    </div>

    <div class="row g-4 mb-4">
      <!-- Stock Movement Chart -->
      <div class="col-lg-7">
        <div class="inv-card h-100">
          <div class="icard-hdr"><i class="bi bi-bar-chart-line-fill me-2"></i>Stock Movements (Jan–Jun 2026)</div>
          <div class="icard-body">
            <div class="chart-legend mb-2">
              <span class="cleg-item"><span class="cleg-dot" style="background:#059669;"></span>Stock In</span>
              <span class="cleg-item ms-3"><span class="cleg-dot" style="background:#ef4444;"></span>Stock Out</span>
            </div>
            <svg viewBox="0 0 545 170" class="inv-svg">
              <text x="42" y="15"  text-anchor="end" class="svg-lbl">800</text>
              <text x="42" y="54"  text-anchor="end" class="svg-lbl">500</text>
              <text x="42" y="93"  text-anchor="end" class="svg-lbl">300</text>
              <text x="42" y="142" text-anchor="end" class="svg-lbl">0</text>
              <line x1="45" y1="14"  x2="540" y2="14"  stroke="#f3f4f6" stroke-width="1"/>
              <line x1="45" y1="52"  x2="540" y2="52"  stroke="#f3f4f6" stroke-width="1"/>
              <line x1="45" y1="90"  x2="540" y2="90"  stroke="#f3f4f6" stroke-width="1"/>
              <line x1="45" y1="140" x2="540" y2="140" stroke="#e5e7eb" stroke-width="1.5"/>
              @for (d of trendData; track d.month; let i = $index) {
                <rect [attr.x]="barX(i,false)" [attr.y]="barY(d.in)"  [attr.width]="barW" [attr.height]="barH(d.in)"  rx="3" fill="#059669" opacity=".85"/>
                <rect [attr.x]="barX(i,true)"  [attr.y]="barY(d.out)" [attr.width]="barW" [attr.height]="barH(d.out)" rx="3" fill="#ef4444" opacity=".75"/>
                <text [attr.x]="monthLblX(i)" [attr.y]="chartBaseY + 14" text-anchor="middle" class="svg-lbl">{{ d.month }}</text>
              }
            </svg>
          </div>
        </div>
      </div>

      <!-- Item Status Donut -->
      <div class="col-lg-5">
        <div class="inv-card h-100">
          <div class="icard-hdr"><i class="bi bi-pie-chart-fill me-2"></i>Stock Status</div>
          <div class="icard-body d-flex align-items-center justify-content-center gap-4 flex-wrap">
            <svg viewBox="0 0 160 160" style="width:155px;height:155px;flex-shrink:0;">
              <circle cx="80" cy="80" r="52" fill="none" stroke="#f3f4f6" stroke-width="22"/>
              @for (seg of statusDonutSegs(); track seg.label) {
                <circle cx="80" cy="80" r="52" fill="none"
                  [attr.stroke]="seg.color" stroke-width="22"
                  [attr.stroke-dasharray]="seg.dash"
                  [attr.stroke-dashoffset]="seg.offset"
                  style="transform:rotate(-90deg);transform-origin:50% 50%;"/>
              }
              <text x="80" y="74" text-anchor="middle" class="svg-center-val">{{ itemStats().total }}</text>
              <text x="80" y="92" text-anchor="middle" class="svg-center-lbl">Items</text>
            </svg>
            <div class="donut-legend">
              <div class="dl-item"><span class="dl-dot" style="background:#059669;"></span><span class="dl-lbl">In Stock</span><span class="dl-val">{{ itemStats().inStock }}</span></div>
              <div class="dl-item"><span class="dl-dot" style="background:#f59e0b;"></span><span class="dl-lbl">Low Stock</span><span class="dl-val text-warning fw-bold">{{ itemStats().lowStock }}</span></div>
              <div class="dl-item"><span class="dl-dot" style="background:#ef4444;"></span><span class="dl-lbl">Out of Stock</span><span class="dl-val text-danger fw-bold">{{ itemStats().outOfStock }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Row -->
    <div class="row g-4">
      <!-- Low Stock Alerts -->
      <div class="col-md-6">
        <div class="inv-card h-100">
          <div class="icard-hdr alert-hdr"><i class="bi bi-exclamation-triangle-fill me-2"></i>Low Stock / Out of Stock Alerts ({{ lowStockItems().length }})</div>
          <div class="icard-body p-0">
            @if (lowStockItems().length === 0) {
              <div class="empty-st p-4 text-center text-muted small"><i class="bi bi-check2-circle me-2 text-success"></i>All items are adequately stocked.</div>
            }
            @for (i of lowStockItems().slice(0,8); track i.id) {
              <div class="alert-row" [class.alert-out]="i.current_stock === 0">
                <div class="ar-cat" [style.background]="getCatBg(i.category)" [style.color]="getCatColor(i.category)">
                  <i class="bi bi-tag-fill"></i>
                </div>
                <div class="ar-info">
                  <div class="ar-name">{{ i.item_name }}</div>
                  <div class="ar-sku">{{ i.item_sku }} · {{ i.category }}</div>
                </div>
                <div class="ar-stock">
                  <div class="ar-qty {{ i.current_stock === 0 ? 'text-danger' : 'text-warning' }} fw-bold">{{ i.current_stock }} {{ i.unit }}</div>
                  <div class="ar-min text-muted small">Min: {{ i.min_stock }}</div>
                </div>
                <span class="{{ getStockStatusClass(stockStatus(i)) }}">{{ stockStatus(i) }}</span>
                <button class="act-btn add-st" (click)="openAddStock(i)" title="Add Stock"><i class="bi bi-plus-lg"></i></button>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Recent Stock Movements -->
      <div class="col-md-6">
        <div class="inv-card h-100">
          <div class="icard-hdr"><i class="bi bi-clock-history me-2"></i>Recent Movements</div>
          <div class="icard-body p-0">
            @for (mv of movements().slice(0,9); track mv.id) {
              <div class="mvmt-row">
                <div class="mv-icon {{ mv.quantity > 0 ? 'mv-in' : 'mv-out' }}">
                  <i class="bi {{ getMovTypeIcon(mv.mov_type) }}"></i>
                </div>
                <div class="mv-info">
                  <div class="mv-name">{{ mv.item_name }}</div>
                  <div class="mv-ref">{{ mv.reference }} · {{ formatDate(mv.mov_date) }}</div>
                </div>
                <div class="mv-qty {{ mv.quantity > 0 ? 'text-success' : 'text-danger' }} fw-bold">
                  {{ mv.quantity > 0 ? '+' : '' }}{{ mv.quantity }}
                </div>
                <div class="mv-bal text-muted small">Bal: {{ mv.balance_after }}</div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ════════════════════════════════════════════════════════
       ITEM MASTER
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'items') {
    <div class="inv-card mb-3"><div class="icard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-5">
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="Name, SKU, category, supplier…"
              [value]="itemSearch()" (input)="itemSearch.set($any($event.target).value)">
            @if (itemSearch()) { <button class="btn btn-outline-secondary" (click)="itemSearch.set('')"><i class="bi bi-x"></i></button> }
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-select" [value]="itemCategory()" (change)="itemCategory.set($any($event.target).value)">
            <option value="">All Categories</option>
            @for (c of uniqueCategories(); track c) { <option [value]="c">{{ c }}</option> }
          </select>
        </div>
        <div class="col-md-2">
          <select class="form-select" [value]="itemStatus()" (change)="itemStatus.set($any($event.target).value)">
            <option value="">All Status</option>
            @for (s of ['In Stock','Low Stock','Out of Stock']; track s) { <option [value]="s">{{ s }}</option> }
          </select>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-secondary" (click)="itemSearch.set(''); itemCategory.set(''); itemStatus.set('')"><i class="bi bi-arrow-counterclockwise"></i></button>
        </div>
      </div>
      <small class="text-muted mt-2 d-block">{{ filteredItems().length }} item(s)</small>
    </div></div>

    @if (filteredItems().length === 0) {
      <div class="empty-st"><i class="bi bi-box"></i><p>No items found</p></div>
    } @else {
      <div class="inv-card">
        <div class="icard-body p-0">
          <div class="table-responsive">
            <table class="inv-table">
              <thead><tr>
                <th>SKU</th><th>Item Name</th><th>Category</th><th class="text-center">Unit</th>
                <th class="text-center">Stock</th><th class="text-center">Min</th><th class="text-center">Max</th>
                <th class="text-end">Cost Price</th><th class="text-end">Stock Value</th>
                <th>Status</th><th>Location</th><th>Actions</th>
              </tr></thead>
              <tbody>
                @for (i of filteredItems(); track i.id) {
                  <tr [class.row-alert]="stockStatus(i) !== 'In Stock'">
                    <td class="font-mono small fw-semibold" [style.color]="getCatColor(i.category)">{{ i.item_sku }}</td>
                    <td>
                      <div class="fw-semibold small">{{ i.item_name }}</div>
                      @if (i.description) { <div class="tiny-meta">{{ i.description }}</div> }
                    </td>
                    <td>
                      <span class="cat-chip" [style.background]="getCatBg(i.category)" [style.color]="getCatColor(i.category)">{{ dataService.getInvCat(i.category) }}</span>
                    </td>
                    <td class="text-center small">{{ i.unit }}</td>
                    <td class="text-center">
                      <div class="stock-qty {{ i.current_stock === 0 ? 'text-danger' : i.current_stock < i.min_stock ? 'text-warning' : 'text-success' }} fw-bold">{{ i.current_stock }}</div>
                      <div class="tiny-progress">
                        <div class="progress" style="height:4px;"><div class="progress-bar {{ i.current_stock === 0 ? 'bg-danger' : i.current_stock < i.min_stock ? 'bg-warning' : 'bg-success' }}" [style.width]="stockPct(i) + '%'"></div></div>
                      </div>
                    </td>
                    <td class="text-center small text-muted">{{ i.min_stock }}</td>
                    <td class="text-center small text-muted">{{ i.max_stock }}</td>
                    <td class="text-end small">{{ formatFull(i.cost_price) }}</td>
                    <td class="text-end small fw-semibold">{{ formatFull(i.current_stock * i.cost_price) }}</td>
                    <td><span class="{{ getStockStatusClass(stockStatus(i)) }}">{{ stockStatus(i) }}</span></td>
                    <td class="small text-muted">{{ i.storage_location || '—' }}</td>
                    <td>
                      <div class="d-flex gap-1">
                        <button class="act-btn add-st" (click)="openAddStock(i)" title="Add Stock"><i class="bi bi-plus-lg"></i></button>
                        <button class="act-btn edit"   (click)="openItemForm(i)"  title="Edit"><i class="bi bi-pencil-fill"></i></button>
                        <button class="act-btn del"    (click)="deleteItem(i.id)" title="Delete"><i class="bi bi-trash3-fill"></i></button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  }

  <!-- ════════════════════════════════════════════════════════
       STOCK LEVELS
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'stock') {
    <div class="inv-card mb-3"><div class="icard-body">
      <div class="input-group" style="max-width:420px">
        <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
        <input class="form-control border-start-0" placeholder="Search items…" [value]="stockSearch()" (input)="stockSearch.set($any($event.target).value)">
      </div>
      <small class="text-muted mt-2 d-block">Items sorted: Out of Stock first, then Low Stock</small>
    </div></div>

    <div class="stock-grid">
      @for (i of filteredStock(); track i.id) {
        <div class="stock-card" [class.sc-out]="i.current_stock === 0" [class.sc-low]="i.current_stock > 0 && i.current_stock < i.min_stock">
          <div class="sc-header">
            <span class="sc-cat" [style.background]="getCatBg(i.category)" [style.color]="getCatColor(i.category)">{{ dataService.getInvCat(i.category) }}</span>
            <span class="{{ getStockStatusClass(stockStatus(i)) }} ms-auto">{{ stockStatus(i) }}</span>
          </div>
          <div class="sc-sku font-mono">{{ i.item_sku }}</div>
          <div class="sc-name">{{ i.item_name }}</div>
          <div class="sc-supplier text-muted small">{{ i.supplier_name }}</div>
          <div class="sc-stock-row">
            <div class="sc-qty {{ i.current_stock === 0 ? 'text-danger' : i.current_stock < i.min_stock ? 'text-warning' : 'text-success' }}">
              {{ i.current_stock }}<span class="sc-unit">{{ i.unit }}</span>
            </div>
            <div class="sc-minmax">Min: {{ i.min_stock }} | Max: {{ i.max_stock }}</div>
          </div>
          <div class="progress my-2" style="height:6px;">
            <div class="progress-bar {{ i.current_stock === 0 ? 'bg-danger' : i.current_stock < i.min_stock ? 'bg-warning' : 'bg-success' }}" [style.width]="stockPct(i) + '%'"></div>
          </div>
          <div class="sc-value text-muted small">Value: {{ formatFull(i.current_stock * i.cost_price) }}</div>
          <div class="sc-footer">
            <button class="scf-btn add" (click)="openAddStock(i)"><i class="bi bi-plus-circle-fill me-1"></i>Add Stock</button>
            <button class="scf-btn issue" (click)="openIssueForm()"><i class="bi bi-box-arrow-up-right me-1"></i>Issue</button>
          </div>
        </div>
      }
    </div>
  }

  <!-- ════════════════════════════════════════════════════════
       PURCHASE ORDERS
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'purchases') {
    <div class="inv-card mb-3"><div class="icard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="PO number, supplier…"
              [value]="poSearch()" (input)="poSearch.set($any($event.target).value)">
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-select" [value]="poStatus()" (change)="poStatus.set($any($event.target).value)">
            <option value="">All Status</option>
            @for (s of ['Draft','Sent','Partial','Received','Cancelled']; track s) { <option [value]="s">{{ s }}</option> }
          </select>
        </div>
        <div class="col-auto"><button class="btn btn-outline-secondary" (click)="poSearch.set(''); poStatus.set('')"><i class="bi bi-arrow-counterclockwise"></i></button></div>
      </div>
      <small class="text-muted mt-2 d-block">{{ filteredPOs().length }} orders</small>
    </div></div>

    @if (filteredPOs().length === 0) {
      <div class="empty-st"><i class="bi bi-cart-x"></i><p>No purchase orders found</p></div>
    } @else {
      <div class="po-list">
        @for (po of filteredPOs(); track po.id) {
          <div class="po-card">
            <div class="poc-left">
              <div class="poc-icon"><i class="bi bi-cart-fill"></i></div>
            </div>
            <div class="poc-main">
              <div class="poc-row1">
                <span class="poc-no font-mono">{{ po.po_no }}</span>
                <span class="{{ getPOStatusClass(po.status) }} ms-1">{{ po.status }}</span>
              </div>
              <div class="poc-sup fw-semibold">{{ po.supplier_name }}</div>
              <div class="poc-meta">
                <span><i class="bi bi-calendar3 me-1"></i>Ordered: {{ formatDate(po.order_date) }}</span>
                <span class="ms-2"><i class="bi bi-clock me-1"></i>Expected: {{ formatDate(po.expected_date) }}</span>
                @if (po.received_date) { <span class="ms-2 text-success"><i class="bi bi-check2 me-1"></i>Received: {{ formatDate(po.received_date) }}</span> }
                <span class="ms-2 text-muted small">{{ po.items.length }} items</span>
              </div>
              @if (po.notes) { <div class="poc-notes">{{ po.notes }}</div> }
            </div>
            <div class="poc-right">
              <div class="poc-total">{{ formatFull(po.total_amount) }}</div>
              <div class="poc-actions mt-2">
                <button class="act-btn view" (click)="viewingPO.set(po)" title="View"><i class="bi bi-eye-fill"></i></button>
                @if (po.status === 'Draft') { <button class="act-btn send" (click)="sendPO(po)" title="Send PO"><i class="bi bi-send-fill"></i></button> }
                @if (po.status === 'Sent' || po.status === 'Partial') { <button class="act-btn recv" (click)="receivePO(po.id)" title="Mark Received"><i class="bi bi-box-arrow-in-down"></i></button> }
                @if (po.status === 'Draft' || po.status === 'Sent') { <button class="act-btn del" (click)="cancelPO(po.id)" title="Cancel"><i class="bi bi-x-circle-fill"></i></button> }
              </div>
            </div>
          </div>
        }
      </div>
    }
  }

  <!-- ════════════════════════════════════════════════════════
       STOCK ISSUES
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'issues') {
    <div class="inv-card mb-3"><div class="icard-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="Issue no., department, purpose…"
              [value]="issSearch()" (input)="issSearch.set($any($event.target).value)">
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-select" [value]="issStatus()" (change)="issStatus.set($any($event.target).value)">
            <option value="">All Status</option>
            @for (s of ['Pending','Approved','Issued','Rejected']; track s) { <option [value]="s">{{ s }}</option> }
          </select>
        </div>
        <div class="col-auto"><button class="btn btn-outline-secondary" (click)="issSearch.set(''); issStatus.set('')"><i class="bi bi-arrow-counterclockwise"></i></button></div>
      </div>
      <small class="text-muted mt-2 d-block">{{ filteredIssues().length }} request(s)</small>
    </div></div>

    @if (filteredIssues().length === 0) {
      <div class="empty-st"><i class="bi bi-inbox"></i><p>No issue requests found</p></div>
    } @else {
      <div class="iss-list">
        @for (iss of filteredIssues(); track iss.id) {
          <div class="iss-card" [class.iss-pending]="iss.status === 'Pending'">
            <div class="isc-left">
              <div class="isc-no font-mono">{{ iss.issue_no }}</div>
              <div class="isc-date">{{ formatDate(iss.request_date) }}</div>
              <span class="{{ getIssStatusClass(iss.status) }} mt-1">{{ iss.status }}</span>
            </div>
            <div class="isc-main">
              <div class="isc-dept"><i class="bi bi-building me-1"></i>{{ iss.department }}</div>
              <div class="isc-by">Requested by: <strong>{{ iss.requested_by }}</strong></div>
              @if (iss.purpose) { <div class="isc-purpose text-muted small">{{ iss.purpose }}</div> }
              <div class="isc-items">
                @for (ln of iss.items.slice(0,3); track ln.item_id) {
                  <span class="isc-item-tag">{{ ln.item_name }} ({{ ln.requested_qty }} {{ ln.unit }})</span>
                }
                @if (iss.items.length > 3) { <span class="text-muted small">+{{ iss.items.length - 3 }} more</span> }
              </div>
            </div>
            <div class="isc-right">
              <div class="isc-count">{{ iss.items.length }} item(s)</div>
              <div class="isc-actions mt-2">
                <button class="act-btn view"    (click)="viewingIssue.set(iss)"  title="View"><i class="bi bi-eye-fill"></i></button>
                @if (iss.status === 'Pending') {
                  <button class="act-btn approve" (click)="approveIssue(iss.id)" title="Approve"><i class="bi bi-check-lg"></i></button>
                  <button class="act-btn del"     (click)="rejectIssue(iss.id)"  title="Reject"><i class="bi bi-x-lg"></i></button>
                }
                @if (iss.status === 'Approved') {
                  <button class="act-btn send" (click)="issueStock(iss.id)" title="Issue Stock"><i class="bi bi-box-arrow-up-right"></i></button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  }

  <!-- ════════════════════════════════════════════════════════
       SUPPLIERS
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'suppliers') {
    <div class="inv-card mb-3"><div class="icard-body">
      <div class="input-group" style="max-width:420px">
        <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
        <input class="form-control border-start-0" placeholder="Supplier name, city, phone…"
          [value]="supSearch()" (input)="supSearch.set($any($event.target).value)">
      </div>
      <small class="text-muted mt-2 d-block">{{ filteredSuppliers().length }} suppliers</small>
    </div></div>

    <div class="sup-grid">
      @for (s of filteredSuppliers(); track s.id) {
        <div class="sup-card" [class.sup-inactive]="!s.is_active">
          <div class="sc2-header">
            <div class="sc2-av">{{ s.sup_name.substring(0,2).toUpperCase() }}</div>
            <div class="sc2-info">
              <div class="sc2-name">{{ s.sup_name }}</div>
              <div class="sc2-cp">{{ s.contact_person }}</div>
            </div>
            @if (!s.is_active) { <span class="inactive-chip ms-auto">Inactive</span> }
          </div>
          <div class="sc2-details">
            @if (s.phone)  { <div class="sc2-detail"><i class="bi bi-telephone-fill me-2"></i>{{ s.phone }}</div> }
            @if (s.email)  { <div class="sc2-detail"><i class="bi bi-envelope-fill me-2"></i>{{ s.email }}</div> }
            @if (s.city)   { <div class="sc2-detail"><i class="bi bi-geo-alt-fill me-2"></i>{{ s.address ? s.address + ', ' : '' }}{{ s.city }}</div> }
            @if (s.gst_no) { <div class="sc2-detail font-mono small"><i class="bi bi-file-earmark-text me-2"></i>GST: {{ s.gst_no }}</div> }
          </div>
          <div class="sc2-footer">
            <span class="sc2-terms"><i class="bi bi-clock me-1"></i>{{ s.payment_terms }}</span>
            <div class="d-flex gap-1 ms-auto">
              <button class="act-btn edit" (click)="openSupplierForm(s)" title="Edit"><i class="bi bi-pencil-fill"></i></button>
              <button class="act-btn {{ s.is_active ? 'del' : 'approve' }}" (click)="toggleSupplier(s.id)" [title]="s.is_active ? 'Deactivate' : 'Activate'">
                <i class="bi {{ s.is_active ? 'bi-toggle-on' : 'bi-toggle-off' }}"></i>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- ════════════════════════════════════════════════════════
       REPORTS
       ════════════════════════════════════════════════════════ -->
  @if (activeTab() === 'reports') {
    <div class="report-tabs mb-4">
      @for (r of [{k:'valuation',l:'Stock Valuation',ic:'bi-currency-rupee'},{k:'lowstock',l:'Low Stock',ic:'bi-exclamation-triangle-fill'},{k:'movements',l:'Movements',ic:'bi-arrow-left-right'},{k:'category',l:'Category Summary',ic:'bi-grid-3x3-gap-fill'}]; track r.k) {
        <button class="rtab" [class.active]="reportView() === r.k" (click)="reportView.set($any(r.k))">
          <i class="bi {{ r.ic }} me-1"></i>{{ r.l }}
        </button>
      }
    </div>

    <!-- Stock Valuation -->
    @if (reportView() === 'valuation') {
      <div class="inv-card">
        <div class="icard-hdr"><i class="bi bi-currency-rupee me-2"></i>Stock Valuation Report (Total: {{ formatFull(itemStats().totalValue) }})</div>
        <div class="icard-body p-0">
          <table class="inv-table">
            <thead><tr><th>SKU</th><th>Item Name</th><th>Category</th><th class="text-center">Unit</th><th class="text-center">Stock Qty</th><th class="text-end">Cost Price</th><th class="text-end">Stock Value</th><th>Status</th></tr></thead>
            <tbody>
              @for (r of valuationReport(); track r.id) {
                <tr>
                  <td class="font-mono small">{{ r.item_sku }}</td>
                  <td class="fw-semibold small">{{ r.item_name }}</td>
                  <td><span class="cat-chip" [style.background]="getCatBg(r.category)" [style.color]="getCatColor(r.category)">{{ dataService.getInvCat(r.category) }}</span></td>
                  <td class="text-center small">{{ r.unit }}</td>
                  <td class="text-center fw-semibold">{{ r.current_stock }}</td>
                  <td class="text-end small">{{ formatFull(r.cost_price) }}</td>
                  <td class="text-end fw-bold">{{ formatFull(r.value) }}</td>
                  <td><span class="{{ getStockStatusClass(r.status) }}">{{ r.status }}</span></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    <!-- Low Stock Report -->
    @if (reportView() === 'lowstock') {
      <div class="inv-card">
        <div class="icard-hdr alert-hdr"><i class="bi bi-exclamation-triangle-fill me-2"></i>Low Stock & Out of Stock Report ({{ lowStockItems().length }} items)</div>
        <div class="icard-body p-0">
          @if (lowStockItems().length === 0) {
            <div class="empty-st p-5"><i class="bi bi-check2-circle text-success"></i><p class="text-success fw-semibold">All items are adequately stocked!</p></div>
          } @else {
            <table class="inv-table">
              <thead><tr><th>SKU</th><th>Item Name</th><th>Category</th><th class="text-center">Current Stock</th><th class="text-center">Min Stock</th><th class="text-center">Shortage</th><th>Status</th><th>Last Purchase</th><th>Supplier</th></tr></thead>
              <tbody>
                @for (i of lowStockItems(); track i.id) {
                  <tr [class.row-alert]="true">
                    <td class="font-mono small">{{ i.item_sku }}</td>
                    <td class="fw-semibold small">{{ i.item_name }}</td>
                    <td><span class="cat-chip" [style.background]="getCatBg(i.category)" [style.color]="getCatColor(i.category)">{{ dataService.getInvCat(i.category) }}</span></td>
                    <td class="text-center fw-bold {{ i.current_stock === 0 ? 'text-danger' : 'text-warning' }}">{{ i.current_stock }} {{ i.unit }}</td>
                    <td class="text-center text-muted">{{ i.min_stock }}</td>
                    <td class="text-center text-danger fw-bold">{{ i.min_stock - i.current_stock }}</td>
                    <td><span class="{{ getStockStatusClass(stockStatus(i)) }}">{{ stockStatus(i) }}</span></td>
                    <td class="small text-muted">{{ formatDate(i.last_purchase_date) }}</td>
                    <td class="small">{{ i.supplier_name }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    }

    <!-- Movements Report -->
    @if (reportView() === 'movements') {
      <div class="inv-card">
        <div class="icard-hdr"><i class="bi bi-arrow-left-right me-2"></i>Stock Movement Log ({{ movements().length }} entries)</div>
        <div class="icard-body p-0">
          <table class="inv-table">
            <thead><tr><th>Type</th><th>Item</th><th>SKU</th><th class="text-center">Quantity</th><th>Reference</th><th>Date</th><th class="text-center">Balance After</th><th>Notes</th></tr></thead>
            <tbody>
              @for (mv of movements().slice(0,20); track mv.id) {
                <tr [class.mv-in-row]="mv.quantity > 0" [class.mv-out-row]="mv.quantity < 0">
                  <td>
                    <span class="mv-type-badge {{ mv.quantity > 0 ? 'mv-in-badge' : 'mv-out-badge' }}">
                      <i class="bi {{ getMovTypeIcon(mv.mov_type) }} me-1"></i>{{ mv.mov_type }}
                    </span>
                  </td>
                  <td class="fw-semibold small">{{ mv.item_name }}</td>
                  <td class="font-mono small">{{ mv.item_sku }}</td>
                  <td class="text-center fw-bold {{ mv.quantity > 0 ? 'text-success' : 'text-danger' }}">{{ mv.quantity > 0 ? '+' : '' }}{{ mv.quantity }}</td>
                  <td class="font-mono small">{{ mv.reference || '—' }}</td>
                  <td class="small text-muted">{{ formatDate(mv.mov_date) }}</td>
                  <td class="text-center small fw-semibold">{{ mv.balance_after }}</td>
                  <td class="small text-muted">{{ mv.notes }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

    <!-- Category Summary -->
    @if (reportView() === 'category') {
      <div class="row g-4">
        <div class="col-lg-7">
          <div class="inv-card h-100">
            <div class="icard-hdr"><i class="bi bi-grid-3x3-gap-fill me-2"></i>Category-wise Stock Value</div>
            <div class="icard-body">
              @for (cat of categoryStats(); track cat.cat) {
                <div class="cat-bar-row mb-3">
                  <div class="cbr-header">
                    <span class="cat-chip" [style.background]="getCatBg(cat.cat)" [style.color]="getCatColor(cat.cat)">{{ dataService.getInvCat(cat.cat) }}</span>
                    <span class="ms-auto fw-semibold small">{{ formatFull(cat.value) }}</span>
                    <span class="text-muted small ms-2">{{ cat.pct }}%</span>
                  </div>
                  <div class="progress mt-1" style="height:10px;border-radius:6px;">
                    <div class="progress-bar" [style.background]="getCatColor(cat.cat)" [style.width]="catBarW(cat.pct)"></div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="inv-card h-100">
            <div class="icard-hdr"><i class="bi bi-table me-2"></i>Category Summary</div>
            <div class="icard-body p-0">
              <table class="inv-table">
                <thead><tr><th>Category</th><th class="text-center">Items</th><th class="text-end">Value</th><th class="text-end">%</th></tr></thead>
                <tbody>
                  @for (cat of categoryStats(); track cat.cat) {
                    <tr>
                      <td><span class="cat-chip" [style.background]="getCatBg(cat.cat)" [style.color]="getCatColor(cat.cat)">{{ dataService.getInvCat(cat.cat) }}</span></td>
                      <td class="text-center">{{ cat.count }}</td>
                      <td class="text-end fw-semibold small">{{ formatFull(cat.value) }}</td>
                      <td class="text-end small">{{ cat.pct }}%</td>
                    </tr>
                  }
                  <tr class="total-row">
                    <td class="fw-bold">Total</td>
                    <td class="text-center fw-bold">{{ itemStats().total }}</td>
                    <td class="text-end fw-bold">{{ formatFull(itemStats().totalValue) }}</td>
                    <td class="text-end fw-bold">100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }
  }

</div>
